import { FreewheelParameterType } from 'tag/ts/tag/ads/freewheel/enums/FreewheelParameterType';
import { AbstractFreewheelParameter } from 'tag/ts/tag/ads/freewheel/parameters/AbstractFreewheelParameter';
export class FmsParameter extends AbstractFreewheelParameter {
    constructor(key, value) {
        super({
            key: key,
            value: value,
            type: FreewheelParameterType.CUSTOM,
            name: `FMS Parameter--${key}`
        });
    }
}
